import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { ApiService } from 'src/app/service/api.service';

@Component({
  selector: 'app-temos-uso',
  templateUrl: './temos-uso.component.html',
  styleUrls: ['./temos-uso.component.css']
})
export class TemosUsoComponent implements OnInit {
  jsonArrayDescricao: any;
  descricao: string = '';
  rmchecked:boolean=false;

  constructor(private apiService: ApiService, private spinner: NgxSpinnerService, private toastr: ToastrService, private router: Router) { }

  ngOnInit() {
    this.spinner.show();
    this.apiService.getListagem('regrasnegocio')
      .subscribe(
        (data) => { //start of (1)

          this.jsonArrayDescricao = data;
          this.descricao = this.jsonArrayDescricao[0].descricao;

          this.spinner.hide();

          //this.getGeolocation();

        }, //end of (1)
        (error: any) => console.log(JSON.parse(JSON.stringify(error))), //(2) second argument
        () => console.log('all data gets') //(3) second argument
      );
  }

  aceitarTermos(e){
    if (e) {
      this.rmchecked = false;
    } else {
      this.rmchecked = true;
    }
  }

  autenticarUsuario(){
    if(this.rmchecked){
      this.router.navigate(['/autenticar'], { replaceUrl: true });
    }else{
      this.toastr.warning('ACEITE O TERMO DE USO PARA CONTINUAR!', 'Atenção!');
    }
  }

}
